export default "__VITE_ASSET__CkUw$dmb__"